import api from 'aio-api'
import helpers from '../utils/helpers'
import moment from 'moment'
import Vue from 'vue'
import Vuex from 'vuex'

import beta from './modules/beta'
import tags from './modules/tags'
import requests from './modules/requests'
import budgets from './modules/budgets'

Vue.use(Vuex)

function initialState () {
  return {
    billing: {},
    card: {},
    categories: [],
    expenses: [],
    invitations: [],
    receipts: [],
    team: [],
    user: {}
  }
}

function sortReceipts (receiptA, receiptB) {
  if (receiptA.created < receiptB.created) return 1
  else if (receiptA.created > receiptB.created) return -1
  else return 0
}

function sortUsers (userA, userB) {
  const nameA = userA.firstName.toLowerCase() + ' ' + userA.lastName.toLowerCase()
  const nameB = userB.firstName.toLowerCase() + ' ' + userB.lastName.toLowerCase()
  if (nameA < nameB) return -1
  else if (nameA > nameB) return 1
  else return 0
}

const index = new Vuex.Store({
  state: initialState,
  mutations: {
    clear (state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setBilling (state, billing) {
      state.billing = billing
    },
    setCard (state, card) {
      state.card = card
    },
    setCategories (state, categories) {
      state.categories = categories
    },
    setExpenses (state, expenses) {
      state.expenses = expenses.sort(helpers.methods.sortExpenses)
    },
    setInvitations (state, invitations) {
      state.invitations = invitations
    },
    setReceipts (state, receipts) {
      state.receipts = receipts.sort(sortReceipts)
    },
    setTeam (state, team) {
      state.team = team.sort(sortUsers)
    },
    setUser (state, user) {
      state.user = user
    }
  },
  actions: {
    async fetchBilling (context) {
      const billing = await api.getBilling()
      context.commit('setBilling', billing)
    },
    async fetchCard (context) {
      if (context.getters.currentUserId) {
        const card = await api.getMyCard(context.getters.currentUserId)
        context.commit('setCard', card)
      }
    },
    async fetchCategories (context) {
      const categories = await api.getCategories()
      context.commit('setCategories', categories)
    },
    async fetchExpenses (context) {
      if (context.getters.currentUserId) {
        const expenses = await api.getExpenses(context.getters.currentUserId)
        context.commit('setExpenses', expenses)
      }
    },
    async fetchInvitations (context) {
      const invitations = await api.getUserInvitations()
      context.commit('setInvitations', invitations)
    },
    async fetchReceipts (context) {
      if (context.getters.currentUserId) {
        const receipts = await api.getReceipts(context.getters.currentUserId)
        context.commit('setReceipts', receipts)
      }
    },
    async fetchTeam (context) {
      if (context.getters.currentUserId) {
        const team = await api.getMyTeam(context.getters.currentUserId)
        context.commit('setTeam', team.membersJson)
      }
    },
    async fetchUser (context) {
      const user = await api.getUser(localStorage.aio_current_user_id)
      context.commit('setUser', user)
    }
  },
  getters: {
    billing: state => state.billing,
    categories: state => state.categories,
    currentUser: state => state.user,
    currentUserId: state => state.user.id,
    currentRole: state => state.user.isAdmin ? 'admin' : state.user.isManager ? 'manager' : 'user',
    doesManageMaster: (state, getters) => {
      return getters.isAdmin || getters.masterBudget?.managerIds?.includes(getters.currentUserId)
    },
    getUser: (state) => (id) => state.team.find(u => u.id === parseInt(id)),
    invitations: state => state.invitations,
    isAdmin: state => state.user.isAdmin,
    isManager: state => state.user.isAdmin || state.user.isManager,
    hasValidBilling: state => {
      const y = state.billing.expYear
      const m = state.billing.expMonth
      if (!(y && m)) {
        return false
      }

      const expiryMoment = moment(`${y}-${m}`, 'YYYY-MM').add(1, 'M')
      return moment().isBefore(expiryMoment)
    },
    looseReceipts: state => state.receipts.filter(r => !r.transactionId),
    myCard: state => state.card,
    myExpenses: state => state.expenses,
    myTeam: state => state.team,
    myTeamWithCards: state => state.team.filter(u => u.hasCard),
    noOfUnclassifiedTransactions: state => state.card.noOfUnclassifiedTransactions,
  },
  modules: {
    beta,
    tags,
    requests,
    budgets,
  }
})

export default index
